import { ArrowUpRight } from 'lucide-react';
import { EXPERIENCES, EDUCATION } from '../data/experiences';
import { PageSection, SectionHeader } from './SectionHeader';
import ResumeLink from './ResumeLink';

function Role({ exp, index }) {
  return (
    <li
      className="reveal grid lg:grid-cols-12 gap-6 lg:gap-10 py-10 lg:py-12 border-t border-line"
      style={{ '--d': `${index * 60}ms` }}
    >
      <div className="lg:col-span-3">
        <p className="font-mono text-xs text-accent">{exp.period}</p>
        <p className="mt-2 font-mono text-[11px] text-faint">
          {exp.location} · {exp.type}
        </p>
      </div>

      <div className="lg:col-span-9">
        <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1">
          <h3 className="display text-2xl sm:text-3xl">{exp.company}</h3>
          <span className="text-sm text-faint">{exp.companyNote}</span>
        </div>
        <p className="mt-2 text-base text-ink/90">{exp.role}</p>
        <p className="mt-4 max-w-2xl text-sm leading-relaxed text-muted">{exp.summary}</p>

        {exp.points && (
          <ul className="mt-6 space-y-2.5 max-w-2xl">
            {exp.points.map((pt) => (
              <li key={pt.slice(0, 40)} className="flex gap-3 text-sm leading-relaxed text-muted">
                <span className="mt-[9px] h-px w-3 shrink-0 bg-line-2" aria-hidden="true" />
                {pt}
              </li>
            ))}
          </ul>
        )}

        {exp.tech && (
          <ul className="mt-6 flex flex-wrap gap-1.5">
            {exp.tech.map((t) => (
              <li key={t} className="chip">{t}</li>
            ))}
          </ul>
        )}
      </div>
    </li>
  );
}

export default function Experience() {
  return (
    <PageSection id="experience">
      <SectionHeader
        index="01"
        label="Experience"
        title="Where I have <em>worked.</em>"
        description="Two ML roles across two countries, plus a stint teaching it. The résumé has the long version."
        action={
          <ResumeLink className="btn-ghost">
            Full résumé
            <ArrowUpRight size={16} aria-hidden="true" />
          </ResumeLink>
        }
      />

      <ol className="border-b border-line">
        {EXPERIENCES.map((exp, i) => (
          <Role key={`${exp.company}-${exp.period}`} exp={exp} index={i} />
        ))}
      </ol>

      <div className="reveal mt-16 grid lg:grid-cols-12 gap-6 lg:gap-10">
        <div className="lg:col-span-3">
          <p className="label">Education</p>
        </div>
        <ul className="lg:col-span-9 grid sm:grid-cols-3 gap-4">
          {EDUCATION.map((edu) => (
            <li key={edu.degree} className="card p-5">
              <p className="font-mono text-[11px] text-faint">{edu.period}</p>
              <p className="mt-3 text-sm font-medium text-ink leading-snug">{edu.degree}</p>
              <p className="mt-1 text-sm text-muted">{edu.school}</p>
              <p className="mt-3 text-xs text-faint leading-relaxed">{edu.focus}</p>
            </li>
          ))}
        </ul>
      </div>
    </PageSection>
  );
}
